"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
const constants_1 = require("./constants");
const helpers_1 = require("./helpers");
exports.Storage = new (class {
    constructor() {
        Object.defineProperty(this, "Key", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: constants_1.StorageKey
        });
        Object.defineProperty(this, "Local", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: helpers_1.StorageLocal
        });
        Object.defineProperty(this, "Cookie", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: helpers_1.StorageCookie
        });
    }
})();
